import axios from "@/api/axiosInstance";
import {
  EnrollmentStatus,
  MyCoursesItem,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

export interface GetMyCoursesResponse {
  data: MyCoursesItem[];
  meta?: Record<string, unknown>;
}

// The caller's transcript ("My Courses"): their enrollments within the active
// company, optionally filtered by enrollment status.
export const getMyCourses = async (
  status?: EnrollmentStatus,
  signal?: AbortSignal,
): Promise<MyCoursesItem[]> => {
  const response = await axios.get<GetMyCoursesResponse>(
    "/api/private/learning-center/my-courses",
    { params: status ? { status } : undefined, signal },
  );
  return response.data.data;
};
